<template>
  <div class="distribution">
    <el-button type="text" size="medium" @click="$router.go(-1)">返回</el-button><br>
    <el-input class="search-el" size="mini" v-model="query.nickname" clearable placeholder="请输入用户昵称"></el-input>
    <el-input class="search-el" size="mini" v-model="query.mobile_phone" clearable placeholder="请输入手机号"></el-input>
    <el-input class="search-el" size="mini" v-model="query.event_nickname" clearable placeholder="请输入受益人昵称"></el-input>

    <el-date-picker size="mini" v-model="query.begin_at" type="datetime" placeholder="支付开始日期" @change="changeHandel">
    </el-date-picker>
    ~
    <el-date-picker size="mini" v-model="query.end_at" type="datetime" placeholder="支付结束日期" @change="changeHandel2">
    </el-date-picker>
    <el-select class="search-el" size="mini" v-model="query.order_status" clearable placeholder="订单状态">
      <el-option label="全部" value="">全部</el-option>
      <el-option label="已取消" :value="0">已取消</el-option>
      <el-option label="待支付" :value="1">待支付</el-option>
      <el-option label="已支付" :value="2">已支付</el-option>
      <el-option label="申请退款" :value="3">申请退款</el-option>
      <el-option label="退款处理中" :value="4">退款处理中</el-option>
      <el-option label="退款成功" :value="5">退款成功</el-option>
      <el-option label="支付中" :value="6">支付中</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-button type="primary" size="mini" @click="exportList()"> 导出</el-button>
    <el-row>
      <el-table v-loading="loading" :data="tableData" border size="mini" :stripe="true"
        style="width: 100%; margin: 10px 0">
        <el-table-column label="ID" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.order_id }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订单号" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.order_no }}</div>
          </template>
        </el-table-column>
        <el-table-column label="昵称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div >{{ row.nickname }}</div>
          </template>
        </el-table-column>
        <el-table-column label="手机号" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div >{{ row.mobile_phone }}</div>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.order_status_msg }}</div>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <div>{{ row.paid_at }}</div>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.total_amount }}</div>
          </template>
        </el-table-column>
        <el-table-column label="受益人昵称" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <div>{{ row.event_user_nickname }}</div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="bott">
      <el-pagination background layout="prev, pager, next" :total="totalItems" :page-size="pageSize"
        :current-page="currentPage" @current-change="handlePageChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getOrderList } from "@/api/distribution"
const axios = require('axios');
export default {
  data() {
    return {
      query: {
        activity_distribution_id: this.$route.query.id,
        nickname: '',
        mobile_phone: '',
        event_nickname: '',
        begin_at: '',
        end_at: '',
        order_status: '',
        limit: 10,
        page: 1,
        event_user_id:this.$route.query.userid,
        target_id:this.$route.query.targetid
      },
      currentPage: 1, // 当前页
      pageSize: 10, // 一页几条
      totalItems: 0,
      tableData: [],
      loading: false,
    }
  },
  mounted() {
    this.loading = false
    this.getList()
  },
  methods: {
    getList() { // 查询列表
      getOrderList(this.query).then((res) => {
        console.log(res);
        this.tableData = res.data.list
        this.totalItems = res.data.total
      })
    },
    derive() { // 添加活动
      // this.$router.push('/distribution/created_activity')
    },
    changeHandel(value) {

      this.query.begin_at = this.dateHandel(value)
    },
    changeHandel2(value) {
      this.query.end_at = this.dateHandel(value)
    },
    dateHandel(date) {
      // 使用 Date 对象的方法获取年、月、日
      let year = date.getFullYear();
      let month = date.getMonth() + 1; // 月份从 0 开始，所以要加 1
      let day = date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();

      // 将月份和日期转换成两位数的字符串，不足两位的在前面补 0
      month = month < 10 ? '0' + month : month;
      day = day < 10 ? '0' + day : day;
      hours = hours < 10 ? '0' + hours : hours;
      minutes = minutes < 10 ? '0' + minutes : minutes;
      seconds = seconds < 10 ? '0' + seconds : seconds;

      // 将年、月、日拼接成 YYYY-MM-DD 格式的字符串
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    },
    handlePageChange(currentPage) {
      this.query.page = currentPage;
      this.getList()
    },
    exportList() {
      this.query.export = 1;
      this.loading = true;

      axios({
        method: 'post',
        url: '/backend/activity/distribution/getOrderList',
        data: this.query,
        responseType: 'blob'
      }).then((res) => {
        console.log(res)
        const link = document.createElement('a')
        let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', '下单人数、活动累计列表.xls')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.loading = false;
        this.query.export = 0;
      }).catch(error => {
        this.$Notice.error({
          title: '错误',
          desc: '网络连接错误'
        })
        console.log(error)
      })
    }
  },
}
</script>

<style>
.distribution {
  cursor: pointer;
}
</style>